<template>
  <div class="h-100 w-100 d-flex"> 

    <div class="d-flex flex-column h-100 w-100 p-1">
      <!-- Options top -->
      <div class="d-flex justify-content-between align-items-center mb-1">
        <b-button variant="outline-secondary" class="size-button-center" @click="$emit('slide_window')">
           <span><feather-icon icon="MenuIcon"/></span>
        </b-button>

        <b-button 
          variant="outline-secondary" 
          class="size-button-center m-5rem icon-setting-sider"
          @click="sider_option_reimagine = !sider_option_reimagine"
        >
          <b-icon icon="gear-wide-connected" font-scale="1.3" variant="dark"></b-icon>
        </b-button>
      </div>
      <!----------------->
      <div class="flex-grow">
        <b-row v-if="loader_images_history">


          <div v-if="is_free" class="d-flex flex-column align-items-center col-12 container-free">
            <div class="d-flex flex-column w-40 align-items-center">
              <h1>{{ $t('ia.reimagine.reimagine') }}</h1>
              <p class="avenir-medium">{{ $t('ia.reimagine.createMultiples') }}</p>
              <div class="position-relative d-flex align-items-center mb-2">
                <video class="video-media-default" muted loop playsinline autoplay :src="require('@/assets/videos/reimagine-sample.mp4')"></video>
              </div>
              <b-button variant="blue-button" class="blue-button w-100 py-4 mb-1" @click="$emit('show_modal_update_suscription')">
                <feather-icon icon="PlusIcon"></feather-icon>
                {{ $t('ia.reimagine.clickOr') }}
              </b-button>
              <p class="avenir-medium">{{ $t('ia.reimagine.OrTry') }}</p>
              <div class="grid">
                <b-img class="image" :src="require(`@/assets/images/portrait/small/avatar-s-${index + 1}.jpg`)" v-for="index in 4" :key="index"></b-img>
              </div>
            </div>
          </div>
          <div :class="`grid-one grid-container m-0 w-100 aspect-one aspect-ratio-1-1 p-1`" v-else>
            <div
              v-for="(data , index) in data_img_ai.length > 0 ? data_img_ai : setting_selected.number_image_ai"
              class="aspect-container-ratio position-relative "
              :key="index"
              :ref="`aspect_ratio_box_${index}`"
            >           
            <div class="h-100 aspect-ratio" :style="`aspect-ratio: ${options_image.aspect_ratio}`">
                <img v-if="data_img_ai.length === 0" :src="require('@/assets/images/svg/stars.svg')" class="img-stars"/>
                <div v-else-if="data_img_ai.length > 0 && !loader_image_search" class="w-100 h-100 position-relative">
                  <img :src="data.url" class="img-ia"/>
                  <div class="container-ia-svg">
                    <img :src="require('@/assets/images/icons/ia.svg')" :alt="`ia-svgd`" class="ia-svg-icon">
                  </div>
                </div>
                <b-skeleton class="skeleton-loading-ia" v-if="loader_image_search"></b-skeleton>
              </div>
              <div class="container-dropdown-image"  @click="downloadFile(data.url)" v-if="data.url">                    
                <feather-icon icon="DownloadIcon"></feather-icon>
              </div>
            </div>
          </div>
        </b-row>
      </div>
  
      <!-- Container search input -->
      <div class="background-input-botton" v-if="!is_free">
        <div class="div-input-button">
          <textarea
            :placeholder="placeholder_text" 
            class="size-input" 
            v-model="setting_selected.promp_ai" 
            autocomplete="off" 
            ref="textInput" 
            @focus="onFocusInputSearch"
            @blur="onBlurInputSearch"
            rows="1"
            @input="autoResize"
          />
          <b-button
            :disabled="setting_selected.promp_ai === null || setting_selected.promp_ai.length < 3 || setting_selected.file === null"
            class="generate-img-ai"
            @click="generateImage()"
            v-if="!loader_image_search"
            >
            {{ data_img_ai.length > 0 ? $t('search.regenerateImg') : $t('search.generateImg')}}
            <b-badge class="badge-button-ia"><feather-icon icon="CodesandboxIcon" class="icon-ia"></feather-icon>{{ getCredits() >= 0 ? getCredits() : $t('ia.general.insufficientCredits') }}</b-badge>
          </b-button>
          <b-skeleton v-else type="button" class="generate-img-ai"></b-skeleton>
        </div>
      </div>
      <!-- Pagination for history view -->
      <!-- <div v-else-if="Object.keys" class="d-flex justify-content-between border-top pt-2">
        <div>
          <b-button variant="outline-secondary" @click="backToHistory()">{{ $t('ia.general.back') }}</b-button>
        </div>
        <div>
          <b-button variant="outline-secondary" @click="$emit('change_uuid', 'backward')">
            <feather-icon icon="ChevronLeftIcon"></feather-icon>
          </b-button>
          <b-button variant="outline-secondary" class="ml-1" @click="$emit('change_uuid', 'forward')">
            <feather-icon icon="ChevronRightIcon"></feather-icon>
          </b-button>
        </div>
      </div> -->
      <!-- -------------------------- -->
    </div>

    <div class="width-right-area" v-if="!is_free">
      <sider-right-reimagine
        class="w-100" 
        :history_images="request_history"
        :options_image="options_image"
        :setting_selected="setting_selected"
        @edit_history="$emit('edit_history')"
        @start_again="startAgain"
        ref="sider_data_upload_image"
      ></sider-right-reimagine>
    </div>

    <!-- Responsive actions right imagine -->
    <b-sidebar v-model="sider_option_reimagine" backdrop shadow right class="sidebar-right-responsive-options-models-ia" v-if="!is_free"> 
      <sider-right-reimagine
        class="w-100" 
        :history_images="request_history"
        :options_image="options_image"
        :setting_selected="setting_selected"
        @edit_history="$emit('edit_history')"
        @start_again="startAgain"
        v-if="sider_option_reimagine"
        ref="sider_data_upload_image"
      ></sider-right-reimagine>
    </b-sidebar>

    <modal-brandme :show_modal="show_modal_not_friendly" :no_footer="true" :key="update_modal_not_friendly">
      <template #title>
        <h5 class="text-center w-100">{{ $t('ia.image.promptBlocked') }}</h5>
      </template>

      <template #body>
        <div class="d-flex flex-column align-items-center justify-content-center pb-1">
          <p class="avenir-medium text-center">{{ $t('ia.image.promptContains') }} <b-link target="_blank" href="https://brandme.la/legal/"> {{ $t('ia.image.termsOfService') }}</b-link>. </p>
          <b-button variant="blue-button" class="blue-button" @click="show_modal_not_friendly = false; update_modal_not_friendly = !update_modal_not_friendly">{{ $t('campaigns.close') }}</b-button>
        </div>
      </template>
    </modal-brandme>
  </div>
</template>
  
<script>
  
import {
  BRow,
  BSkeleton,
  BButton,
  BBadge,
  BImg,
  BLink,
  BSidebar,
} from 'bootstrap-vue';
import { getDetailHistory, createVariationsImage, getPriceActions } from '@/services/ia';
import { downloadFile, showToast, getUniqueIndex } from '@/libs/utils/others';
import { getUserData } from '@/libs/utils/user';
  
export default {
  name: 'ContainerReimagine',
  components: {
    BRow,
    BSkeleton,
    BButton,
    BLink,
    BBadge,
    BImg,
    BSidebar,
    ModalBrandme: () => import('../modal/ModalBrandme.vue'),
    SiderRightReimagine: () => import('./siderbars/siderRightReimagine.vue'),
  },
  props: {
    history_images: {
      type: Object,
      default: () => {
        return {}
      },
    },
    credits_avaible: {
      type: Number,
      default: 0
    }
  },
  computed: {
    is_free() {
      return getUserData().current_plan.name.toLowerCase() === 'free';
    },
    get_size_respecting_aspect() {
      const aspect_ratio_sizes = {
        '16/9':   { width: 1280, height: 720 },
        '5/4':    { width: 1000, height: 800 },
        '4/3':    { width: 1200, height: 900 },
        '1/1':    { width: 1024, height: 1024 },
        '3/4':    { width: 900, height: 1200 },
        '4/5':    { width: 800, height: 1000 },
        '9/16':   { width: 720, height: 1280 }
      };
      return aspect_ratio_sizes[this.options_image.aspect_ratio];
    },
  },
  data() {
    return {
      downloadFile,
      placeholder_text: '',
      data_img_ai: [],
      sider_option_reimagine: false,
      setting_selected: {
        promp_ai: null,
        ia_selected: this.$t('search.ia_options')[0],
        number_image_ai: 1,
        negative_prompt: undefined,
        size_images_selected: this.$t('search.size_images')[2],
        file: null,
      },
      options_image: {
        model: {value: 33, category: 'imagine_v5', name: 'Imagine V5'},
        aspect_ratio: '1/1',
        art_style: null,
        cfg: 3,
        steps: 30,
        seed: null,
        high_res_results: 0,
      },
      loader_image_search: false,
      update_sidebar: false,
      loader_images_history: false,
      request_history: {},
      is_focus: false,
      price_images: {},
      show_modal_not_friendly: false,
      update_modal_not_friendly: false,
      file_cropped: null,
    }
  },
  created() {
    if (Object.keys(this.history_images).length > 0) this.data_img_ai = this.history_images.response_server.data;
    if (this.$route.params.uuid) {
      this.getDetailHistoryImages()
    } else {
      this.loader_images_history = true
    }
    this.getPriceImage();
    this.$root.$on('images_created_ws_or_variant', (data) => {
      this.request_history = data.body;
      this.data_img_ai = Array.isArray(data.body.response_server.data) ? data.body.response_server.data : [];
      this.loader_image_search = false;
      this.loader_images_history = true;
      if (data.body.status === 'complete') {
        this.$emit('update_credits', this.getCredits())
        this.$root.$emit('update_credits_drop', this.getCredits())
      }
    });
  },
  mounted() {
    this.startAnimation();
  },
  methods: {
    startAgain() {
      this.request_history = null;
      this.data_img_ai = null;
      this.setting_selected =  {
        promp_ai: null,
        number_image_ai: 1,
        size_images_selected: this.$t('search.size_images')[2],
        file: null,
      };
      this.data_img_ai = []
    },
    async adjustImage() {
      const image = new Image();
      image.crossOrigin = "anonymous";
      image.src = this.request_history?.data?.origin_image ?? URL.createObjectURL(this.setting_selected.file);

      await new Promise((resolve) => {
        image.onload = resolve
      });

      const aspectRatio = this.makeDivision(this.options_image.aspect_ratio);
      const canvas = this.$refs.sider_data_upload_image.$refs.canvas_preview_reimagine
      const ctx = canvas.getContext('2d');

      if (aspectRatio >= 1) {
        canvas.width = 400;
        canvas.height = canvas.width / aspectRatio;
      } else {
        canvas.height = 400;
        canvas.width = canvas.height * aspectRatio;
      }

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const imageAspectRatio = image.width / image.height;
      let drawWidth = 0; let drawHeight = 0; let offsetX = 0; let offsetY = 0;

      if (imageAspectRatio > aspectRatio) {
        drawHeight = canvas.height;
        drawWidth = drawHeight * imageAspectRatio;
        offsetX = (canvas.width - drawWidth) / 2;
        offsetY = 0;
      } else {
        drawWidth = canvas.width;
        drawHeight = drawWidth / imageAspectRatio;
        offsetX = 0;
        offsetY = (canvas.height - drawHeight) / 2;
      }

      ctx.drawImage(image, offsetX, offsetY, drawWidth, drawHeight);

      const dataURL = canvas.toDataURL();
      this.file_cropped = this.dataURLtoFile(dataURL, `${getUniqueIndex()}.png`);
    },
    makeDivision(string) {
      const [num1, num2] = string.split('/').map(Number);      
      return num1 / num2;
    },
    dataURLtoFile(dataURL, filename) {
      const arr = dataURL.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      
      return new File([u8arr], filename, { type: mime });
    },
    autoResize() {
      const el = this.$refs.textInput
      el.style.height = "auto"
      el.style.height = `${Math.min(el.scrollHeight, 140)}px`
    },
    getPriceImage() {
      getPriceActions().then((response) => {
        this.price_images = response;
      })
    },
    async typeWriter(text, index, speed) {
      if (index < text.length && !this.is_focus) {
        this.placeholder_text += text.charAt(index);
        await this.sleep(speed);
        await this.typeWriter(text, index + 1, speed);
      }
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async animatePlaceholder(text, speed) {
      this.placeholder_text = '';
      await this.typeWriter(text, 0, speed);
    },
    startAnimation() {
      const placeholder_text = this.$t('search.describeChange');
      const speed = 50;
      this.animatePlaceholder(placeholder_text, speed);
    },
    onFocusInputSearch() {
      this.is_focus = true;
      this.placeholder_text = '';
    },
    onBlurInputSearch() {
      this.is_focus = false;
      this.startAnimation();
    },
    getDetailHistoryImages() {
      getDetailHistory(this.$route.params.uuid).then((response) => {
        this.request_history = response;
        this.loader_images_history = true;
        this.data_img_ai = response.response_server.data;
        this.setting_selected.promp_ai = response.original_prompt;
        this.setting_selected.number_image_ai = response.num_images;
        this.setting_selected.negative_prompt = response.data.negative_prompt;
        this.setting_selected.file_variants = response.data.origin_image;
        this.update_sidebar = !this.update_sidebar

 
        if (response.data.model) this.setting_selected.ia_selected = this.$t('search.ia_options').find((ia_op) => ia_op.value === response.data.model)
      })
    },
    getCredits() {
      return this.credits_avaible >= this.price_images.variant_image_gpt_1 ? this.price_images.variant_image_gpt_1 : -1;
    },
    async generateImage() {  
      if (this.getCredits() >= 0) {
        this.loader_image_search = true
        await this.adjustImage();

        const data = new FormData();
        data.append('prompt', this.setting_selected.promp_ai);
        data.append('number', 1);
        data.append('width', 1024);
        data.append('height', 1024);
        data.append('image', this.file_cropped);


        createVariationsImage(data).then((response) => {
          if (response.status >= 400) {
            this.loader_image_search = false;

            showToast(this, 'danger', 'AlertCircleIcon', 'search.mesageError')
          }
        });
      } else this.$emit('show_modal_update_suscription')
    },
  },
  watch: {
    '$i18n.locale'() {
      this.startAnimation();
    }
  }
}
</script>
<style lang="scss" scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  .image {
    width: 100%;
    height: 100%;
    border-radius: 10px;
  }
}
.container-free { 
  .w-40 {
    width: 30%;

    @media (max-width: 2000px) {
      width: 40%;
    }
    @media(max-width: 1800px) {
      width: 50%;
    }
    @media(max-width: 1200px) {
      width: 70%;
    }
    @media(max-width: 700px) {
      width: 90%;
    }
  }
  .video-media-default {
    width: 100%;
    border-radius: 10px;
    max-height: 400px
  }
} 
.aspect-one {
  grid-template-columns: repeat(1, 1fr);
  display: flex;
  justify-content: center;
}
.size-input::placeholder {
  color: #70747c;
}
.width-right-area {
  width: 420px;
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
  overflow-y: scroll;
  overflow-x: hidden;
}
.size-button-center {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1rem;
  height: 3rem;
}
.m-5rem {
  margin-left: 0.5rem;
}
.icon-setting-sider{
  background-color: #e9ecef;
  display: none;
}
.background-input-botton{
  width: 100%;
  padding: 1em 0 0 0;
}
.div-input-button{
  backdrop-filter: blur(2px);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0.5rem;
  padding: 0.5em;
  display: flex;
  align-items: flex-end;
  gap: 0.5em;
  
  .badge-button-ia {
    display: flex;
    align-items: center;
    margin-left: 0.5em;
    line-height: 10px;
    background-color: #40736E;
    .icon-ia {
      width: 14px;
      height: 14px;
      margin-right: 0.2em;
    }
  }
}
.size-input{
  resize: none;
  background-color: transparent;
  min-height: 42px;
  max-height: 140px;
  flex-grow: 1;
  font-size: 15px;
  font-weight: bold;
  border: none;
  box-shadow: none !important;
  font-family: monospace !important;
  line-height: 1.5;
  padding: 0.6em 0;
  overflow-y: auto;

  @media(max-width: 500px) {
    font-size: 14px;
  }
  
  &::placeholder {
    color: #70747c;
  }
}
.generate-img-ai{
  height: 42px;
  min-height: 42px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  background: linear-gradient(to left bottom, rgb(124, 214, 175), rgb(62, 123, 160));
}
.grid-container {
  display: grid;
  grid-gap: 14px;
  grid-auto-flow: dense;
  .grid-col-span {
    grid-column-end: span 2;
    grid-row-end: span 2;
  }
}
.grid-one {
  grid-template-columns: repeat(1, 1fr);
  display: flex;
  aspect-ratio: 2 / 1;
  max-height: 500px;
  justify-content: center;
}

.aspect-ratio {
  background: linear-gradient(0deg, rgba(250,250,250,1) 0%, rgba(219,219,219,1) 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  
  .skeleton-loading-ia {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
  }
  .img-stars {
    width: 25%;
    height: 25%;
    color: #d3d3d3;
  }
  .img-ia {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .container-ia-svg {
    position: absolute;
    width: 5%;
    height: 5%;
    right: 5%;
    bottom: 5%;
    display: flex;
    justify-content: center;
    align-items: center;
    .ia-svg-icon {
      width: 170%;
      height: 170%;
    }
  }
}
.container-dropdown-image {
  background-color: rgba(0, 0, 0, 0.699);
  position: absolute;
  top: 5%;
  border-radius: 0.5em;
  right: 5%;
  padding: 0.5em;
  color: white;
  cursor: pointer;
  transform: translateX(100px);
}
.aspect-container-ratio {
  overflow: hidden;
  &:hover {
    .container-dropdown-image {
      animation: dropdown-animation 300ms forwards;
    }
  }
  &:not(:hover) { 
    .container-dropdown-image {
      animation: dropdown-animation-back 300ms forwards;
    }
  }
}
@media (max-width: 1199px) {
  .icon-setting-sider{
    display: flex;
  }
  .width-right-area {
    display: none;
  }
}

@media (max-width: 770px) {
  .max-width-disabled{
    display: none;
  }
}


@keyframes dropdown-animation {
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes dropdown-animation-back {
  0% {
    transform: translateX(0px);
  }
  100% {
    transform: translateX(50px);
    opacity: 0;
  }
}
</style>
<style lang="scss">
.sidebar-right-responsive-options-models-ia .b-sidebar {
  width: 400px;
}
.dropdown-options-image .btn {
  padding: 0.5em !important;
}
</style>